import { Box } from '@mui/material'
import { EmtButton, EmtIcon, EmtTypography } from 'emt-components-v2'

interface AnimalBoxProps {
  color?: string
  disabled?: boolean
  slug?: 'dog' | 'cat' | 'nac'
  count?: number
  onChange?: (delta: number) => void
  showIcon?: boolean
}

const nameForSlug = {
  dog: 'Chien(s)',
  cat: 'Chat(s)',
  nac: 'Autre(s)',
}

const AnimalBox: React.FC<AnimalBoxProps> = ({
  color = 'purple',
  disabled = false,
  slug = 'dog',
  count = 0,
  onChange,
  showIcon = true,
}) => {
  return (
    <Box
      sx={{
        minWidth: 0,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '16px',
          padding: '12px 10px',
          // border: `1px solid ${count > 0 ? '#AE59C6' : '#E8E8EA'}`,
          border: `1px solid #E8E8EA`,
          backgroundColor: '#fff',
          borderRadius: '16px',
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '5px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
            {showIcon && (
              <Box
                className="EmtInlineCard-image-wrapper"
                sx={{
                  position: 'relative',
                  width: '30px',
                  height: '30px',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexShrink: 0,
                  backgroundColor: `${count > 0 ? '#F7EEF9' : '#F6F6F6'}`,
                  borderRadius: '12px',
                }}
              >
                <EmtIcon
                  className={`emt-${slug}`}
                  size="small"
                  sx={{
                    color: `${count > 0 ? '#AE59C6' : '#A5A3A9'}`,
                  }}
                />
              </Box>
            )}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: 0,
              }}
            >
              <EmtTypography
                variant="body2"
                fontWeight="700"
                sx={{
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  flexShrink: 1,
                  fontSize: '12px',
                }}
              >
                {nameForSlug[slug]}
              </EmtTypography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <EmtButton
              variant="secondary"
              disabled={count === 0}
              color={color}
              size="small"
              className="!min-w-[unset] w-[24px] h-[24px] !p-0 flex-shrink-0"
              sx={{ borderRadius: '10px' }}
              onClick={() => onChange && onChange(-1)}
            >
              <EmtIcon className="emt-minus" size="small" />
            </EmtButton>
            <EmtTypography variant="body1" fontWeight="700">
              {count}
            </EmtTypography>
            <EmtButton
              variant="contained"
              color={color}
              size="small"
              className="!min-w-[unset] w-[24px] h-[24px] !p-0 flex-shrink-0"
              sx={{ borderRadius: '10px' }}
              onClick={() => onChange && onChange(1)}
            >
              <EmtIcon className="emt-add" size="small" sx={{ fontSize: '15px' }} />
            </EmtButton>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AnimalBox
